// document.addEventListener("DOMContentLoaded", () => {  
//   const menu = document.querySelector(".header__inline-menu");  
//   if (menu){  
//     const items = menu.querySelectorAll("details");
//     items.forEach(item => {  
//     //   item.addEventListener("mouseover", () => {
//     //   item.querySelector('summary').setAttribute("aria-expanded",true);
//     //   item.setAttribute("open", true);   
//     //   const ul = item.querySelector("ul");  
//     //   if (ul) {  
//     //     ul.addEventListener("mouseleave", () => {  
//     //     item.removeAttribute("open");  
//     //     }); 
//     //   } 
//     // });
//     item.addEventListener("mouseleave", () => { 
//       item.removeAttribute("open"); 
//       item.querySelector('summary').setAttribute("aria-expanded",false);
//     }); 
//   }); 
//   } 
//   else { 
//     console.error("Menu not found: Ensure that '.header__inline-menu' exists in the HTML."); 
//   } 
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const drawer = document.querySelector(".header-drawer");
//   const closeBtn = document.querySelector(".itg-cross-header-drawer");

//   if (drawer && closeBtn) {
//     closeBtn.addEventListener("click", function () {

//       drawer.classList.add("closing");

   
//       setTimeout(() => {
//         drawer.removeAttribute("open");
//         drawer.classList.remove("closing"); 
//       }, 400); 
//     });
//   }
// });



// document.addEventListener("DOMContentLoaded", function () {
//   const closeBtn = document.querySelector(".itg-cross-header-drawer");
//   const drawer = document.querySelector(".header-drawer");
//   const drawerMenu = document.querySelector(".header__inline-menu .drawer-menu");

//   if (drawer && drawerMenu && closeBtn) {

//     closeBtn.addEventListener("click", function () {
//       drawerMenu.style.transform = "translateX(-100%)";
//       setTimeout(function () {
//         drawer.removeAttribute("open");
//         drawerMenu.style.transform = "";
//       }, 350);

//     });

//   }
// });


document.addEventListener("DOMContentLoaded", function () {

  const drawer = document.querySelector(".header-drawer");
  const drawerMenu = document.querySelector(".drawer-menu");
  const closeBtn = document.querySelector(".itg-cross-header-drawer svg");
  const summaryToggle = document.querySelector(".header-drawer summary");

  if (!drawer || !drawerMenu || !closeBtn) return;

  const overlay = document.createElement("div");
  overlay.classList.add("drawer-overlay");
  document.body.appendChild(overlay);

  summaryToggle.addEventListener("click", function () {
    setTimeout(() => {
      if (drawer.hasAttribute("open")) {
        overlay.classList.add("active");
      }
    }, 10);
  });

  function closeDrawerSmooth() {
    drawerMenu.style.transform = "translateX(-100%)";
    overlay.classList.remove("active");

    setTimeout(function () {
      drawer.removeAttribute("open");
      drawerMenu.style.transform = "";
    }, 350);
  }

  closeBtn.addEventListener("click", closeDrawerSmooth);
  overlay.addEventListener("click", closeDrawerSmooth);

});




//   document.addEventListener("DOMContentLoaded", function () {
//   const drawer = document.querySelector(".header-drawer");
//   const closeBtn = document.querySelector(".itg-cross-header-drawer");

//   if (drawer && closeBtn) {
//     closeBtn.addEventListener("click", function () {
//       drawer.removeAttribute("open"); 
//     });
//   }
// });
